import { Input } from "components/ui/input";

const initialValue = {
  op: "contains",
  value: "",
};

export function TextFilter({ descriptor, value, onChange }) {
  const current = value ?? initialValue;

  return (
    <Input
      type={descriptor.inputType ?? "text"}
      value={current.value ?? ""}
      onChange={e => onChange({ ...current, value: e.target.value })}
      placeholder="Value"
      className="tw:bg-white tw:dark:bg-background"
    />
  );
}
